export default "__VITE_ASSET__BdTMJwI$__"